import { TicketType } from '../enums/ticket-type.enum';
import { TicketStatus } from '../enums/ticket-status.enum';

export const TicketTypeDescription = {
  [TicketType.DeleteCustomer]: 'Delete Customer'
};

export const TicketStatusDescription = {
  [TicketStatus.Approved]: 'Approved',
  [TicketStatus.Archived]: 'Archived',
  [TicketStatus.New]: 'New',
  [TicketStatus.Waiting]: 'Waiting',
  [TicketStatus.Resolved]: 'Resolved',
  [TicketStatus.Canceled]: 'Canceled',
  [TicketStatus.Deleted]: 'Deleted'
};

export const TicketStatusColor = {
  [TicketStatus.Approved]: 'lightblue',
  [TicketStatus.Archived]: 'gray',
  [TicketStatus.New]: 'blue',
  [TicketStatus.Waiting]: 'cyan',
  [TicketStatus.Resolved]: 'green',
  [TicketStatus.Canceled]: 'red',
  [TicketStatus.Deleted]: 'gray'
};
